/**
 * Developer command console — opened with T while the debug overlay (`) is on.
 * A single-line text input at the bottom of the screen; Enter runs the command
 * (via the caller's handler, whose feedback string is echoed), Escape closes it.
 *
 * The caller is responsible for suppressing game input while `isOpen()` so
 * typing doesn't drive the character.
 */

export class DebugConsole {
  private readonly root: HTMLElement;
  private readonly input: HTMLInputElement;
  private readonly echo: HTMLElement;
  private open_ = false;

  constructor(host: HTMLElement, onCommand: (cmd: string) => string) {
    this.root = document.createElement('div');
    this.root.className = 'debug-console';
    this.root.style.display = 'none';
    this.root.innerHTML = `
      <div class="dc-echo"></div>
      <div class="dc-line"><span class="dc-prompt">&gt;</span><input class="dc-input" type="text"
        autocomplete="off" spellcheck="false" placeholder="kill guard" /></div>`;
    this.input = this.root.querySelector('.dc-input') as HTMLInputElement;
    this.echo = this.root.querySelector('.dc-echo') as HTMLElement;
    host.appendChild(this.root);

    this.input.addEventListener('keydown', (e) => {
      e.stopPropagation(); // don't let the game's window listener see it
      if (e.key === 'Enter') {
        const cmd = this.input.value.trim();
        this.input.value = '';
        if (cmd) this.echo.textContent = onCommand(cmd);
      } else if (e.key === 'Escape') {
        this.close();
      }
    });
  }

  isOpen(): boolean {
    return this.open_;
  }

  open(): void {
    this.open_ = true;
    this.root.style.display = 'block';
    this.input.value = '';
    this.input.focus();
  }

  close(): void {
    this.open_ = false;
    this.root.style.display = 'none';
    this.input.blur();
  }
}
